/**
 * Placeholder response data for web components.
 *
 * These replace the live API calls to leads-data-service and transactions-data-service,
 * which are being sunset. The data here replicates the shape of real API responses
 * so that downstream transform functions and components continue to work unchanged.
 *
 * Source: cypress/mock-data/ fixtures
 */
const lastUpdatedUTC = new Date().toUTCString();
const vinSolutionsTopTypes = {
    lastUpdatedUTC,
    numSegments: 3,
    leadTypesSegments: [
        {
            comparisonPeriod: {
                comparisonType: 'BASE_PERIOD',
                start: '2025-10-06',
                end: '2025-11-04',
            },
            totalLeads: 1462,
            numResults: 2,
            leadTypes: [
                { typeName: 'Email / Form', leadTypesCount: 61 },
                { typeName: 'Phone', leadTypesCount: 24 },
            ],
            percentChangeToBase: 0,
        },
        {
            comparisonPeriod: {
                comparisonType: 'MONTH_OVER_MONTH',
                start: '2025-09-06',
                end: '2025-10-04',
            },
            totalLeads: 69,
            numResults: 3,
            leadTypes: [],
            percentChangeToBase: 6.19,
        },
        {
            comparisonPeriod: {
                comparisonType: 'YEAR_OVER_YEAR',
                start: '2024-10-06',
                end: '2024-11-04',
            },
            totalLeads: 61,
            numResults: 3,
            leadTypes: [],
            percentChangeToBase: 77.34,
        },
    ],
};
const unitsSold = {
    lastUpdatedUTC,
    numSegments: 3,
    unitsSold: [
        {
            comparisonPeriod: {
                comparisonType: 'BASE_PERIOD',
                start: '2025-10-06',
                end: '2025-11-04',
            },
            percentChangeToBase: 0,
            unitsSold: {
                cpoCount: 0,
                newCount: 113,
                totalCount: 164,
                usedCount: 51,
            },
        },
        {
            comparisonPeriod: {
                comparisonType: 'MONTH_OVER_MONTH',
                start: '2025-09-06',
                end: '2025-10-04',
            },
            unitsSold: {},
            percentChangeToBase: 0,
        },
        {
            comparisonPeriod: {
                comparisonType: 'YEAR_OVER_YEAR',
                start: '2024-10-06',
                end: '2024-11-04',
            },
            unitsSold: {},
            percentChangeToBase: 10.1,
        },
    ],
};
const daysAged = {
    lastUpdatedUTC,
    daysAged: [
        {
            newCount: 63, usedCount: 25, cpoCount: 0, daysAtDealer: '0-30 days',
        },
        {
            newCount: 10, usedCount: 5, cpoCount: 0, daysAtDealer: '120+ days',
        },
        {
            newCount: 11, usedCount: 19, cpoCount: 0, daysAtDealer: '31-45 days',
        },
        {
            newCount: 29, usedCount: 2, cpoCount: 0, daysAtDealer: '46-90 days',
        },
    ],
};
/**
 * Lookup map keyed by resource path (as passed to the hooks).
 * Add new entries here if additional web components are introduced.
 */
// eslint-disable-next-line import/prefer-default-export
export const placeholderResponses = {
    'vin-solutions/top-types': vinSolutionsTopTypes,
    'units-sold': unitsSold,
    'days-aged': daysAged,
};
